import React, { useEffect, useRef, useState } from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { useSignedInState, useSignedInUserState } from "../hooks/useAuthState";
import { LottieIndicator } from "../shared/lottieIndicator";

export const VerifyEmailPage: React.FC = () => {
    const [loadingAnimationData, setLoadingAnimationData] = useState<any>(null);
    const [successAnimationData, setSuccessAnimationData] = useState<any>(null);
    const user = useSignedInUserState().user;
    const loadingAnimationPath = "/animation/verify_email.json";
    const successAnimationPath = "/animation/email_verified.json"

    useEffect(() => {
        fetch(loadingAnimationPath)
            .then((response) => response.json())
            .then((data) => setLoadingAnimationData(data))
            .catch((error) => console.error("Error loading Lottie animation:", error));
    }, [loadingAnimationPath]);
    useEffect(() => {
        fetch(successAnimationPath)
            .then((response) => response.json())
            .then((data) => setSuccessAnimationData(data))
            .catch((error) => console.error("Error loading Lottie animation:", error));
    }, [successAnimationPath]);


    return (
        <Box
            sx={{
                backgroundColor: "#f5f9e9",
                minHeight: "100vh",
                display: "flex",
                alignItems: "top",
                justifyContent: "center",
            }}
            className="body"
        >
            <Container>
                {
                    (user && !user.emailVerified) ?
                        < LottieIndicator data={loadingAnimationData} message="We've sent you a confirmation email - please check your inbox and click the link to verify your account." />
                        :
                        <Box sx={{
                            display: "flex",
                            justifyContent: "center",
                            paddingTop: '16px'
                        }}>
                            <a
                                style={{
                                    backgroundColor: '#162C1F',
                                    border: 'none',
                                    color: '#fff',
                                    padding: '0.75rem 2rem',
                                    cursor: 'pointer',
                                    borderRadius: '25px',
                                    fontSize: '18px',
                                    fontWeight: '500',
                                    textDecoration: 'none',
                                    paddingTop: '16px'
                                }}
                                href="/search"
                            >
                                Browse Deals
                            </a>
                            < LottieIndicator data={successAnimationData} message="Your account has been successfully created! 🎉 Please check your inbox to verify your email before getting started." />

                        </Box>
                }
            </Container>
        </Box>
    );
};
